"use strict";

export default (flex = window.flex) => {

    const { setStore, safeJSONParse, lzDecompress } = flex;

    const APP_MODEL_ID = 'flexModel';
    const encodedAppContext = document.getElementById(APP_MODEL_ID).innerHTML;
    const appContext = safeJSONParse(lzDecompress(encodedAppContext));

    setStore({ appContext });
};